/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Web_Page_EmptyInputs */

const en_conversion_error_web_page_empty = /** @type {(inputs: Conversion_Error_Web_Page_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not read any content from this web page.`)
};

const es_conversion_error_web_page_empty = /** @type {(inputs: Conversion_Error_Web_Page_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos leer ningún contenido de esta página web.`)
};

/**
* | output |
* | --- |
* | "We could not read any content from this web page." |
*
* @param {Conversion_Error_Web_Page_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_web_page_empty = /** @type {((inputs?: Conversion_Error_Web_Page_EmptyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Web_Page_EmptyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_web_page_empty(inputs)
	return en_conversion_error_web_page_empty(inputs)
});